import { render, staticRenderFns } from "./taintsTemplate.vue?vue&type=template&id=bc89d044&"
import script from "./taintsTemplate.vue?vue&type=script&lang=js&"
export * from "./taintsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./taintsTemplate.vue?vue&type=style&index=0&id=bc89d044&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports